import { ensureBase64Decoded } from './getAuthorization';
/**
 * Returns consumerId from JWT.
 */
export function getConsumerId(data) {
    if (!data)
        return;
    try {
        const token = ensureBase64Decoded(data);
        if (!token)
            return;
        const { consumerId, sub } = JSON.parse(atob(token.split('.')[1]));
        return consumerId || sub;
    }
    catch (error) {
        console.warn('Error decoding JWT', error);
    }
}
